import { defineStore } from "pinia";
const useSiteInformation = defineStore("siteInformation", {
  state: () => ({
    "agencyId": undefined,
    "siteName": "微课资源学习",
    "versionNumber": "奥思·微课资源及案例系统",
    "recordNumber": "京ICP备10010903号",
    "companyPhone": "400 073 0087",
    "companyEmail": "sales@kingchannels.com",
    "companyAddress": "北京市海淀区西三旗建材城内3幢一层107号",
    "companyWebsite": "www.kingchannels.com",
    "copyrightInformation": "©2017 中新金桥 版权所有 2006-2024",
    "onlineDuration": 50,
    "themeColor": "#EF6937",
    "topBarBackgroundColor": null,
    "logo": "https://zxjq-gx.obs.cn-east-2.myhuaweicloud.com/%E8%BD%AF%E4%BB%B6%E9%80%9A%E5%88%86%E4%BA%AB/rjt_logo.png",
    "isShowGame":true,
    "topBarImg": 'white'
}),
  persist: true,
  getters: {},

  actions: {},
});

//暴露这个useCounter模块
export default useSiteInformation;
